<template>
  <v-slide-x-reverse-transition>
    <v-card class="elevation-5 provider-details vop-bg-whisper " v-show="isVisible">
      <div>
        <!-- Title -->
        <v-toolbar flat color="vop-bg-whisper">
          <v-toolbar-title class="subheading ttu font-weight-medium">
            <span v-if="isEditMode">{{ messages.label.EDIT_PROVIDER }}</span>
            <span v-else>{{ messages.label.ADD_PROVIDER }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="hide()">
            <v-icon medium>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 v-if="providerError !== ''">
              <v-alert :value="true" type="error">
                {{ providerError }}
              </v-alert>
            </v-flex>
            <v-flex xs10>
              <v-form>
                <v-flex xs11>
                  <v-text-field v-model="provider.title" clearable v-validate="'required|max:100'"
                    :error-messages="errors.collect('title')" data-vv-name="title" :counter="100"
                    :label="messages.label.TITLE" required>
                  </v-text-field>
                </v-flex>
                <v-flex xs11>
                  <span class="body-1 grey--text text--darken-1">Alternate Names</span>
                  <template v-for="(item, index) in alternateNamesArray">
                    <v-layout wrap class="pl-2 pr-2" :key="index">
                      <v-flex xs6>
                        <v-text-field v-model="item.key" clearable
                          v-validate="checkAlternateNamesValidation(item.value) ? 'required|alpha_num' : ''"
                          :error-messages="getErrorMessages(item.key, item.value, 'key')" data-vv-name="key"
                          :label="messages.label.KEY">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field v-model="item.value" clearable
                          v-validate="checkAlternateNamesValidation(item.key) ? 'required|alpha_num' : ''"
                          :error-messages="getErrorMessages(item.key, item.value, 'value')" data-vv-name="value"
                          :label="messages.label.VALUE">
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </template>
                  <v-btn color="primary" flat small round @click="addMoreAlternateNames()">
                    <v-icon small left>add_circle</v-icon><span>{{ messages.label.ADD }}</span>
                  </v-btn>
                </v-flex>
                <v-flex xs11>
                  <v-autocomplete v-model="selectedProviderGroup" :label="messages.label.PROVIDER_GROUP"
                    :disabled="isEditMode" v-validate="'required'" :error-messages="errors.collect('providerGroup')"
                    data-vv-name="providerGroup" :items="providerGroups" item-text="title" item-value="title"
                    return-object required>
                    <template v-slot:no-data>
                      <v-list-tile>
                        <v-list-tile-title>
                          No Provider groups in
                          <strong>{{ mpxParentAccount.title }}</strong>
                        </v-list-tile-title>
                      </v-list-tile>
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
      </div>
      <v-card-actions class="px-3">
        <v-spacer />
        <!-- Delete Provider -->
        <v-dialog v-model="deleteDialog" width="500" v-if="isEditMode">
          <v-btn color="error" slot="activator">
            {{ messages.label.DELETE }}
          </v-btn>
          <v-card>
            <v-card-title class="headline font-weight-light">
              {{ messages.label.DELETE_PROVIDER }}
            </v-card-title>
            <v-card-text>
              <p>{{ messages.info.DELETE_PROVIDER_1 }} <b>{{ provider.title }}</b> ? </p>
              <p v-html="messages.info.DELETE_PROVIDER_2"></p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey lighten-1 white--text" @click="deleteDialog = false">
                {{ messages.label.CANCEL }}
              </v-btn>
              <v-btn color="error" :disabled="deletingProvider" :loading="deletingProvider" @click="deleteProvider()">
                {{ messages.label.DELETE }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn color="primary" class="ml-2" :disabled="updatingProvider" :loading="updatingProvider" v-if="isEditMode"
          @click="updateProvider">
          {{ messages.label.SAVE }}
        </v-btn>
        <v-btn color="primary" class="ml-2" :disabled="addingProvider" :loading="addingProvider" v-else
          @click="addProvider">
          {{ messages.label.ADD }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-slide-x-reverse-transition>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import ProvidersService from "@/Providers/ProvidersService"
import AppService from "@/AppService"
import messages from "@/Providers/messages.json"
import * as providersDataService from "@/Providers/ProvidersDataService"
import { VOD_SYCN_PREINGEST_DATA_SERVICE_URL } from "@/store/constants/getter-types"

/**
 * initialData
 */
function initialData(instance) {
  return {
    isVisible: false,
    isEditMode: false,
    provider: {
      title: "",
      providerGroupId: ""
    },
    providerError: "",
    addingProvider: false,
    updatingProvider: false,
    selectedProviderGroup: {},
    deleteDialog: false,
    deletingProvider: false,
    alternateNamesArray: [],
    dictionary: instance.getValidationDictionary()
  }
}

export default {
  name: "ProviderDetails",
  components: {},
  $_veeValidate: {
    validator: "new"
  },
  data: function () {
    return initialData(this)
  },
  computed: {
    ...mapState([
      "providerGroups", "mpxParentAccount"
    ]),
    ...mapGetters([
      VOD_SYCN_PREINGEST_DATA_SERVICE_URL
    ])
  },
  methods: {

    /**
     * reset
     */
    reset() {
      Object.assign(this.$data, initialData(this))
    },

    /**
     * Hide side sheet view
     */
    hide() {
      this.isVisible = false
      this.providerError = ""
      this.resetProviderData()
      ProvidersService.$emit("event:hideProviderDetailsSheet")
    },
    /**
     * Show side sheet view
     */
    show(providerObj) {
      this.resetProviderData()
      if (!this.$lodash.isUndefined(providerObj)) {
        this.isEditMode = true
        this.provider = this.$lodash.cloneDeep(providerObj)
        this.generateAlternateNamesArray(this.provider)
        this.selectedProviderGroup = this.providerGroups.find(
          (obj) => obj.id === providerObj.providerGroupId
        )
      } else {
        this.$validator.reset()
        this.isEditMode = false
      }
      this.providerError = ""
      this.isVisible = true
    },

    /**
    * Validation messages for vee-validate
    */
    getValidationDictionary() {
      return {
        custom: {
          title: {
            required: () => "Title can't be empty",
            max: "Title may not be greater than 100 characters"
          },
          providerGroup: {
            required: () => "Please select a Provider Group"
          },
          key: {
            required: () => "Key can't be empty",
            alpha_num:
              "Key may only contain alphabetic characters or numbers"
          },
          value: {
            required: () => "Value can't be empty",
            alpha_num:
              "Value may only contain alphabetic characters or numbers"
          }
        }
      }
    },
    /**
    * To check if validation gets applied to field or not
    */
    checkAlternateNamesValidation(value) {
      if (value !== null && value.length > 0) {
        return true
      } else {
        return false
      }
    },
    /**
    * retrun the error message based on validation
    */
    getErrorMessages(key, value, pairName) {
      let alphaNumRegex = new RegExp("^[a-zA-Z0-9]*$")
      switch (pairName) {
        case "key":
          if (value !== null && value.length > 0) {
            if (key === null || key.length === 0) {
              return "Key can't be empty"
            } else if (!alphaNumRegex.test(key)) {
              return "Key may only contain alphabetic characters or numbers"
            }
          }
          break
        case "value":
          if (key !== null && key.length > 0) {
            if (value === null || value.length === 0) {
              return "Value can't be empty"
            } else if (!alphaNumRegex.test(value)) {
              return "Value may only contain alphabetic characters or numbers"
            }
          }
          break
      }
    },
    /**
    * Convert aletrnateNames object into alternateNames Array
    */
    generateAlternateNamesArray(providerObj) {
      this.alternateNamesArray = []
      if (!this.$lodash.isEmpty(providerObj.alternateNames) && !this.$lodash.isUndefined(providerObj.alternateNames)) {
        let that = this
        Object.keys(providerObj.alternateNames).forEach(function (key) {
          that.alternateNamesArray.push({ key: key, value: providerObj.alternateNames[key] })
        })
      } else {
        this.alternateNamesArray.push({ key: "", value: "" })
      }
    },
    /**
     * Re-initialize
     */
    resetProviderData() {
      this.provider = {
        title: "",
        providerGroupId: ""
      }
      this.selectedProviderGroup = ""
      this.generateAlternateNamesArray(this.provider)
    },
    /**
     * Add new provider group
     */
    addProvider() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.provider.providerGroupId = this.selectedProviderGroup.id
          this.provider.ownerId = this.selectedProviderGroup.ownerId
          this.provider.alternateNames = this.getAlternateNamesObject()
          this.addingProvider = true
          return providersDataService.addProvider(
            this.provider,
            this.VOD_SYCN_PREINGEST_DATA_SERVICE_URL)
            .then((response) => {
              this.isVisible = false
              this.providerError = ""
              this.resetProviderData()
              ProvidersService.$emit("event:updateProviderList")
              ProvidersService.$emit("event:providerAdded")
              return response
            })
            .catch((error) => {
              let response = error.response.data
              if (response.isException) {
                this.providerError = response.description
              }
              return Promise.reject(error)
            })
            .finally(() => {
              this.addingProvider = false
            })
        }
      })
    },
    /**
     * Update provider details
     */
    updateProvider() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.provider.providerGroupId = this.selectedProviderGroup.id
          this.provider.ownerId = this.selectedProviderGroup.ownerId
          this.provider.alternateNames = this.getAlternateNamesObject()
          this.updatingProvider = true
          return providersDataService.updateProvider(
            this.provider,
            this.VOD_SYCN_PREINGEST_DATA_SERVICE_URL)
            .then((response) => {
              this.isVisible = false
              this.providerError = ""
              this.resetProviderData()
              ProvidersService.$emit("event:updateProviderList")
              ProvidersService.$emit("event:providerUpdated")
              return response
            })
            .catch((error) => {
              let response = error.response.data
              if (response.isException) {
                this.providerError = response.description
              }
              return Promise.reject(error)
            })
            .finally(() => {
              this.updatingProvider = false
            })
        }
      })
    },
    /**
     * Delete provider details
     */
    deleteProvider() {
      this.deletingProvider = true
      let providerId = this.provider.id.split("/").pop()
      return providersDataService.deleteProvider(
        providerId,
        this.VOD_SYCN_PREINGEST_DATA_SERVICE_URL)
        .then((response) => {
          this.isVisible = false
          this.providerError = ""
          this.resetProviderData()
          ProvidersService.$emit("event:updateProviderList")
          ProvidersService.$emit("event:providerDeleted")
          return response
        })
        .catch((error) => {
          let response = error.response.data
          if (response.isException) {
            this.providerError = response.description
          }
          return Promise.reject(error)
        })
        .finally(() => {
          this.deleteDialog = false
          this.deletingProvider = false
        })
    },
    /**
     * getAlternateNamesObject - Convert alternateNames array into alternateNames object
     */
    getAlternateNamesObject() {
      let returnObject = {}
      for (let item in this.alternateNamesArray) {
        let key = this.alternateNamesArray[item].key
        let value = this.alternateNamesArray[item].value
        if (key !== null && key.length > 0 && value !== null && value.length > 0) {
          let keyValuePair = {}
          keyValuePair[key] = value
          Object.assign(returnObject, keyValuePair)
        }
      }
      return returnObject
    },
    /**
     * addMoreAlternateNames - For adding more alternateNames Fields
     */
    addMoreAlternateNames() {
      this.alternateNamesArray.push({ key: "", value: "" })
    }
  },
  mounted() {
    this.$validator.localize("en", this.dictionary)
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Events
     */
    ProvidersService.$on("event:showProviderDetailsSheet", this.show)
    AppService.$on("event:mpxAccountChanged", this.reset)
  },
  beforeDestroy() {
    AppService.$off("event:mpxAccountChanged", this.reset)
  }
}
</script>

<style lang="scss">
.provider-details {
  min-height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/Providers/ProviderList/ProviderDetails.vue